import * as core from '../../../../../../../core'

import { query } from './training-implications-by-workstream.query'

export const RESOURCE = {
  payload: {
    alias: 'training.implications.by.workstream',
    description: 'Chart view of training implications by workstream',
    name: 'Training Implications by Workstream',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
